/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { BillingInfo } from './billing-info';
// May contain unused imports in some cases
// @ts-ignore
import type { LastLogins } from './last-logins';
// May contain unused imports in some cases
// @ts-ignore
import type { Platforms } from './platforms';

/**
 * 
 * @export
 * @interface CustomerDTO
 */
export interface CustomerDTO {
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'status'?: CustomerDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'joinDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'lastBill'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerDTO
     */
    'devices'?: number;
    /**
     * 
     * @type {Platforms}
     * @memberof CustomerDTO
     */
    'platforms'?: Platforms;
    /**
     * 
     * @type {LastLogins}
     * @memberof CustomerDTO
     */
    'lastLogins'?: LastLogins;
    /**
     * 
     * @type {BillingInfo}
     * @memberof CustomerDTO
     */
    'billingInfo'?: BillingInfo;
    /**
     * 
     * @type {number}
     * @memberof CustomerDTO
     */
    'councilId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'councilName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'deleteAccountTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerDTO
     */
    'ownedActorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'purgeScheduledAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDTO
     */
    'ownedActorType'?: string;
}

export const CustomerDTOStatusEnum = {
    Unregistered: 'UNREGISTERED',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Suspended: 'SUSPENDED',
    Deleted: 'DELETED'
} as const;

export type CustomerDTOStatusEnum = typeof CustomerDTOStatusEnum[keyof typeof CustomerDTOStatusEnum];


